"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _AssetDetails = _interopRequireDefault(require("../../AssetDetails"));

require("../styles/_video-details-modal.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var VideoDetailsModal = /*#__PURE__*/function (_Component) {
  _inherits(VideoDetailsModal, _Component);

  var _super = _createSuper(VideoDetailsModal);

  function VideoDetailsModal(props) {
    var _this;

    _classCallCheck(this, VideoDetailsModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "updateInitialFields", function (output) {
      _this.setState({
        name: output ? (0, _getVideoOutputName.default)(output, output.video.name) : '',
        description: (0, _lodash.default)(output, 'description', ''),
        tags: (0, _lodash.default)(output, 'tags', ''),
        key: (0, _lodash.default)(output, 'outputId', '')
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleUpdateOutput", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, updateOutput, output, onComplete, _this$state, name, description, tags, _yield$updateOutput, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, updateOutput = _this$props.updateOutput, output = _this$props.output, onComplete = _this$props.onComplete;
              _this$state = _this.state, name = _this$state.name, description = _this$state.description, tags = _this$state.tags;
              _context.next = 4;
              return updateOutput({
                outputId: output.outputId,
                name: name,
                description: description || void 0,
                tags: tags || void 0
              });

            case 4:
              _yield$updateOutput = _context.sent;
              data = _yield$updateOutput.data;
              error = _yield$updateOutput.error;

              if (!(!data || !data.updateOutput || error)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return");

            case 9:
              onComplete(data.updateOutput);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "updateField", function (field) {
      return function (value) {
        _this.setState(_defineProperty({}, field, (0, _getValueFromGenericInput.getStringValueFromGenericInput)(value)));
      };
    });

    var _output = props.output;
    _this.state = {
      name: _output ? (0, _getVideoOutputName.default)(_output, _output.video.name) : '',
      description: (0, _lodash.default)(_output, 'description', ''),
      tags: (0, _lodash.default)(_output, 'tags', ''),
      key: ''
    };
    return _this;
  }

  _createClass(VideoDetailsModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var output = this.props.output;

      if (prevProps.output !== output) {
        this.updateInitialFields(output);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          hideModal = _this$props2.hideModal,
          output = _this$props2.output;

      var _ref2 = output || {},
          video = _ref2.video,
          latestVersion = _ref2.latestVersion,
          _ref2$versions = _ref2.versions,
          versions = _ref2$versions === void 0 ? [] : _ref2$versions;

      var _this$state2 = this.state,
          name = _this$state2.name,
          description = _this$state2.description,
          tags = _this$state2.tags,
          key = _this$state2.key;
      var outputName = output ? (0, _getVideoOutputName.default)(output, video.name) : '';

      var _ref3 = versions.find(function (_ref4) {
        var versionNumber = _ref4.versionNumber;
        return versionNumber === latestVersion;
      }) || {},
          assetId = _ref3.assetId;

      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "video-details-modal"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
          visible: Boolean(output),
          title: "Video Details",
          subtitle: "View and manage details of this Video",
          saveText: "SAVE CHANGES",
          onClose: hideModal,
          onSave: this.handleUpdateOutput,
          saveDisabled: !name,
          stayOpenOnSave: true
        }, /*#__PURE__*/_react.default.createElement(_AssetDetails.default, {
          assetId: assetId,
          outputName: outputName
        }), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Basic Info")), /*#__PURE__*/_react.default.createElement("div", {
          className: "video-details-modal__fields"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
          label: "TITLE*",
          onChange: this.updateField('name'),
          defaultValue: name,
          key: "".concat(key, "-name")
        }), /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
          className: "video-details-modal__fields__desc",
          label: "DESCRIPTION",
          placeholder: "Enter description",
          multiline: true,
          defaultValue: description,
          onChange: this.updateField('description'),
          key: "".concat(key, "-desc"),
          rows: 3
        }), /*#__PURE__*/_react.default.createElement(_uiKit.TagInput, {
          defaultValue: tags,
          onChange: this.updateField('tags'),
          label: "TAGS",
          key: "".concat(key, "-tags")
        }))))
      );
    }
  }]);

  return VideoDetailsModal;
}(_react.Component);

var _default = VideoDetailsModal;
exports.default = _default;